/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { ROUTER, VARCHAR_MAX_LENGTH, VARCHAR_MIN_LENGTH } from 'app/constants';
import { blogService, categoryService, commonService, tagService } from 'app/services';
import validatorChain from 'app/utils/validator-chain';
import Base64UploadAdapter from 'app/views/pages/blog/base64';
import { HttpStatusCode } from 'axios';
import { t } from 'i18next';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { MultiSelect } from 'primereact/multiselect';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
// import { redirect } from 'react-router-dom';
export default function AddBlog() {
    // const location = useLocation();
    const [Title, setTitle] = useState('');
    const [selectedTag, setTag] = useState([]);
    const [SpecialContent, setSpecialContent] = useState('');
    const [Content, setContent] = useState('');
    const [optionCategory, setOptionCategory] = useState([]);
    const [optionTag, setOptionTag] = useState([]);
    const [error, setError] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState();
    const navigate = useNavigate();
    /**
     * Add blog
     */
    /**
     * Validate data
     * @returns Boolean
     */
    const validateData = () => {
        const errors = {
            Title: validatorChain(Title)
                .isRequire('M001')
                .isLength({ min: VARCHAR_MIN_LENGTH, max: VARCHAR_MAX_LENGTH }, 'M003')
                .getError(),
            selectedTag: validatorChain(selectedTag).isRequire('M001').getError(),
            selectedCategory: validatorChain(selectedCategory).isRequire('M001').getError(),
            SpecialContent: validatorChain(SpecialContent).isRequire('M001').getError(),
            Content: validatorChain(Content).isRequire('M001').getError()
        };
        setError(errors);
        return Object.values(errors).reduce((r, c) => (c === null ? r : false), true);
    };
    // eslint-disable-next-line no-unused-vars
    const add = async () => {
        if (validateData()) {
            const res = await blogService.create({
                Title,
                Content,
                Images: '',
                Category: selectedCategory,
                Tag: selectedTag,
                SpecialContent
            });
            if (res.status === HttpStatusCode.Ok) {
                commonService.toast.show({
                    severity: 'success',
                    summary: t('INFO_MESSAGE'),
                    detail: t('M020')
                });
                navigate(ROUTER.BLOG);
            } else {
                commonService.toast.show({
                    severity: 'error',
                    summary: t('ERROR_MESSAGE'),
                    detail: t('M009')
                });
            }
        }
    };
    const getCategory = async () => {
        const data = await categoryService.search({ searchField: '', sortField: 'UpdatedAt', sortOrder: 1, first: 0, rows: 1000 });
        setOptionCategory(data.data);
    };
    const getTag = async () => {
        const data = await tagService.search({ searchField: '', sortField: 'UpdatedAt', sortOrder: 1, first: 0, rows: 1000 });
        setOptionTag(data.data);
    };
    /**
     * Fetch first render data
     */
    useEffect(() => {
        commonService.preloader.hide();
        getCategory();
        getTag();
    }, []);
    return (
        <div>
            <div className='auto-container row container-rooms pb-4'>
                <div className='col-12'>
                    <h2 className='fw-bold'>{t('BTN_ADD_BLOG')}</h2>
                    <div className='row'>
                        <div className='col-md-4 py-2'>
                            <label htmlFor='title'>{t('LABEL_BLOG_TITLE')}</label>
                            <InputText value={Title} onChange={(e) => setTitle(e.target.value)} className='w-100' id='title' />
                        </div>
                        <div className='col-md-4 py-2'>
                            <label htmlFor='Category'>{t('LABEL_CATEGORY')}</label>
                            <Dropdown
                                className='w-100 fs-md ms-3 multi-select-systems'
                                value={selectedCategory}
                                options={optionCategory}
                                optionLabel='Name'
                                optionValue='ID'
                                onChange={(e) => {
                                    setSelectedCategory(e.value);
                                }}
                            />
                        </div>
                        <div className='col-md-4 py-2'>
                            <label htmlFor='Tag'>{t('LABEL_TAG')}</label>
                            <MultiSelect
                                value={selectedTag}
                                onChange={(e) => setTag(e.value)}
                                options={optionTag}
                                optionLabel='Name'
                                optionValue='ID'
                                maxSelectedLabels={3}
                                id='disability'
                                className='w-100'
                            />
                        </div>
                        <div className='col-md-4 py-2'>
                            <label className='break-work text-danger'>{t(error['Title'])}</label>
                        </div>
                        <div className='col-md-4 py-2'>
                            <label className='break-work text-danger'>{t(error['selectedCategory'])}</label>
                        </div>
                        <div className='col-md-4 py-2'>
                            <label className='break-work text-danger'>{t(error['selectedTag'])}</label>
                        </div>
                        <div className='col-md-12 py-2'>
                            <label htmlFor='specialcontent'>{t('LABEL_SPECIAL_CONTENT')}</label>
                            <InputTextarea
                                value={SpecialContent}
                                onChange={(e) => setSpecialContent(e.target.value)}
                                className='w-100'
                                id='specialcontent'
                                rows={5}
                                cols={20}
                            />
                        </div>
                        <div className='col-md-12 py-2'>
                            <label className='break-work text-danger'>{t(error['SpecialContent'])}</label>
                        </div>
                        <div className='col-md-12 py-2'>
                            <label htmlFor='content'>{t('TABLE_LABEL_CONTENT')}</label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={Content}
                                config={{
                                    extraPlugins: [Base64UploadAdapterPlugin]
                                    // toolbar: [
                                    //     'heading',
                                    //     '|',
                                    //     'bold',
                                    //     'italic',
                                    //     'link',
                                    //     'bulletedList',
                                    //     'numberedList',
                                    //     '|',
                                    //     'imageUpload',
                                    //     'blockQuote',
                                    //     'undo',
                                    //     'redo'
                                    // ]
                                }}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setContent(data);
                                    console.log('Data Change: ', { event, editor, data });
                                }}
                                // onReady={(editor) => {
                                //     // You can store the "editor" and use when it is needed.
                                //     console.log('Editor is ready to use!', editor);
                                // }}
                                // onBlur={(event, editor) => {
                                //     // console.log('Blur.', editor);
                                // }}
                                // onFocus={(event, editor) => {
                                //     // console.log('Focus.', editor);
                                // }}
                            />
                        </div>
                        <div className='col-md-12 py-2'>
                            <label className='break-work text-danger'>{t(error['Content'])}</label>
                        </div>
                        <div className='row mx-0 py-4 d-flex justify-content-center align-items-center'>
                            <Button className='btn-cancel-sm mx-2' variant='default' onClick={() => add()}>
                                {t('BTN_ADD_BLOG')}
                            </Button>
                            <Button className='btn-action-sm mx-2' variant='default' onClick={() => navigate(ROUTER.BLOG)}>
                                {t('LABEL_CANCEL')}
                            </Button>
                        </div>
                        {/* <div style={{ marginTop: '20px', border: '1px solid #ccc', padding: '10px' }}>
                            <h3>Nội dung sau khi lưu:</h3>
                            <div dangerouslySetInnerHTML={{ __html: Content }} />
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}
// Plugin Base64UploadAdapter để upload ảnh dạng Base64
function Base64UploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new Base64UploadAdapter(loader);
    };
}
